
import { useState } from 'react';
import Header from './components/Header';
import FilterSection from './components/FilterSection';
import VehicleGrid from './components/VehicleGrid';
import Footer from '../../components/feature/Footer';
import SEOHead from '../../components/base/SEOHead';

export default function Fleet() {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [priceRange, setPriceRange] = useState([0, 200]);
  const [selectedFeatures, setSelectedFeatures] = useState<string[]>([]);

  const schemaData = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "name": "Car2Go Vehicle Fleet",
    "description": "Complete fleet of rental vehicles including economy cars, luxury sedans, SUVs, and commercial vehicles available for rent in New Jersey",
    "url": `${import.meta.env.VITE_SITE_URL || "https://www.cartogo.co"}/fleet`,
    "provider": {
      "@type": "AutoRental",
      "name": "Car2Go",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "28 Hollis Rd",
        "addressLocality": "East Brunswick",
        "addressRegion": "NJ",
        "postalCode": "08816",
        "addressCountry": "US"
      }
    },
    "itemListElement": [
      {
        "@type": "Product",
        "name": "Economy Car Rental",
        "description": "Fuel-efficient economy cars perfect for city driving and daily commutes",
        "category": "Economy Cars"
      },
      {
        "@type": "Product", 
        "name": "Luxury Car Rental",
        "description": "Premium luxury vehicles for business meetings and special occasions",
        "category": "Luxury Cars"
      },
      {
        "@type": "Product",
        "name": "SUV Rental",
        "description": "Spacious SUVs ideal for family trips and group transportation",
        "category": "SUVs"
      },
      {
        "@type": "Product",
        "name": "Commercial Vehicle Rental",
        "description": "Commercial vehicles for business and cargo transportation needs",
        "category": "Commercial Vehicles"
      }
    ]
  };

  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="Car Rental Fleet East Brunswick NJ | Economy Luxury SUV Commercial Vehicles"
        description="Browse Car2Go's complete vehicle fleet in East Brunswick, NJ. Economy cars, luxury sedans, SUVs, and commercial vehicles available for rent. Professional car rental service with competitive rates and modern fleet."
        keywords="car rental fleet, economy cars, luxury vehicles, SUV rental, commercial vehicle rental, East Brunswick fleet"
        canonical={`${import.meta.env.VITE_SITE_URL || "https://www.cartogo.co"}/fleet`}
        ogTitle="Car2Go Vehicle Fleet - Economy, Luxury, SUV & Commercial Rentals"
        ogDescription="Complete vehicle fleet available for rent in East Brunswick, NJ. Economy cars, luxury sedans, SUVs, and commercial vehicles with professional service."
        schemaData={schemaData}
      />
      <Header />
      <FilterSection 
        selectedCategory={selectedCategory}
        setSelectedCategory={setSelectedCategory}
        priceRange={priceRange}
        setPriceRange={setPriceRange}
        selectedFeatures={selectedFeatures}
        setSelectedFeatures={setSelectedFeatures}
      />
      <VehicleGrid 
        selectedCategory={selectedCategory}
        priceRange={priceRange}
        selectedFeatures={selectedFeatures}
      />
      <Footer />
    </div>
  );
}